import { usePathname } from 'next/navigation';

export const useCountryFromUrl = (): string => {
  const pathname = usePathname();
  const segments = pathname.split('/').filter(Boolean);
  const country = segments[0] || 'mx';

  return country;
};
